module.exports = __webpack_public_path__ + "static/media/truck.de051ddc.svg";